<template>
  <div class="querydept_main">
    <ball></ball>
    <div class="nav">
      <van-nav-bar
        title="科室类别"
        left-arrow
        left-text="返回"
        @click-left="onClickLeft"
      />
    </div>
    <div class="body">
      <div>
        <!--  -->
        <van-sidebar v-model="activeKey" type="primary" class="dypeList">
          <van-sidebar-item
            v-for="(item, index) in dypeList"
            :key="index"
            :title="item.deptName"
            @click="getdeptid(item)"
          />
        </van-sidebar>
      </div>
    
      <div class="querydept_cell">
        <div>
          <div v-if="empty_D_flag">
            <van-empty
              image="https://account.kmmds.top/datainfo_pic/error.png"
              description="该科室暂无排班"
            />
          </div>
          <div class="D_btn_right" v-else>
            <div class="aa"></div>
            <van-button
              color="#5B8DF6"
              class="D_btn"
              size="large"
              @click="godetails_d()"
              >挂号</van-button
            >
          </div>
          <!-- <van-cell
            v-else
            class="cellltem"
            title="预约挂号"
          /> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Nav from "./../../components/nav.vue";
import { Dialog } from "vant";
import setOptions from "@/mixins/setOption";
export default {
  mixins: [setOptions],
  data() {
    return {
      //单元格点击事件  true 有排班  false没排班
      clickflag: null,
      regfre: "",
      Cflag: true,
      deptflag: false,
      name: "",
      isFirstEnter: false,
      navTitle: "科室列表",
      activeKey: 0,
      index: 0,
      dypeList: [],
      depy_type: "",
      method_depy_type: [],
      reglevelList: [],
      emptyflag: false,
      dept_id: null,
      empty_D_flag: false,
      //挂号排班类型
      register_sched: "",
      // 挂号级别
      register_level: "",
      wx_pub_id: ""
    };
  },
  components: {
    Nav
  },
  mounted() {
    // this.getDeptList();
    this.getrerinfo();
  },
  methods: {
    getdeptid(item) {
      this.method_depy_type = item;
     
      this.nextfalg = item.IsEndPoint;
    },
    onClickLeft() {
      this.$router.push("/index");
    },
    //跳转C版无排班挂号页

    //跳转D版
    godetails_d() {
      if (this.nextfalg == "0") {
        this.$router.push({
          path: "/ylzyy_scheduldetail",
          query: {
            deptid: this.method_depy_type.deptId,
            dept_type: this.method_depy_type,
            regfre:  this.method_depy_type.cost
          }
        });
      }else if(this.nextfalg=="1"){
      
          this.$router.push({
        path: "/details_ymzyy",
        query: {
          deptid: this.method_depy_type.deptId,
          dept_type: this.method_depy_type,
          register_level: "N",
          regfre: this.method_depy_type.cost,
        },
      });
      }
    },
    //判断版本和排版类型
    async getrerinfo() {
      try {
        this.$showLoad();
        let url = "/hospitalconf/index/getdictionaries";
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          null,
          data => {
            //  console.log(data.data)
            this.wx_pub_id = data.data.wx_pub_id;
            // 挂号级别
            this.register_level = data.data.register.register_level;
            //  排班
            this.register_sched = data.data.register.register_sched;
            //  挂号类型
            this.register_type = data.data.register.register_type;
            this.getDeptList();
            // if (register_sched == "Y") {
            //   //通过科室ID获取该科室下的挂号级别列表
            //   this.getDeptList();
            // } else if (this.register_sched == "N") {
            //   //显示挂号预约按钮
            //   //判断是否有挂号级别===》
            //   if (this.register_level == "Y") {
            //     this.getDeptList();
            //   } else if (this.register_level == "N") {
            //     this.regfre = data.data.register.price;
            //     this.Cflag = false;
            //     this.getDeptList();
            //   }
            // }
            this.$hideLoad();
          }
        );
      } catch (error) {
        // console.log(error);
        this.$hideLoad();
      }
    },
    //跳转下一页 传递参数
    godocLIst(item, key) {
      // console.log(this.name)
      // console.log(key)
      this.$router.push({
        path: "/schedulhead",
        query: {
          dept_deptId: this.method_depy_type.deptId,
          dype_type_name: key,
          dype_type_key: item,
          dypename: this.name
        }
      });
      // console.log(dept_deptId)
    },
    //获取挂号类型和id

    async getDeptList() {
      //获取科室列表
      try {
        this.$showLoad();
        // this.isLoad = true
        let url = "/register/querydept";
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          null,
          data => {
            //  console.log(this.wx_pub_id)
           
              this.dypeList = data.data.data
           
             this.getdeptid( this.dypeList[0])
            this.$hideLoad();
          }
        );
      } catch (error) {
        // console.log(error);
        this.$hideLoad();
      }
    }
  }
};
</script>

<style  lang="scss" scoped>
.van-sidebar-item--select::before {
  background-color: #5b8df6;
}
.querydept_main {
  display: flex;
  flex-direction: column;
  max-height: 100vh;
  max-width: 100vw;
}
.body {
  flex: 1;
  display: flex;
  flex-direction: row;
  .dypeList {
    max-height: 94vh;
    width: 28vw;
    line-height: 50px;
  }
  .dis {
    font-size: 14px;
    line-height: 35px;
    color: #7f8c8d;
    text-align: left;
  }
  .querydept_cell {
    display: flex;
    flex-direction: column;
    width: 80vw;
    height: 90vh;

    .D_btn_right {
      height: 85vh;
      .aa {
        height: 85vh;
      }
    }
    .cellltem {
      line-height: 35px;
      text-align: center;
    }
  }
}
</style>